import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { LoginService } from '@services/login/login.service';
import { SnackBarService } from '@services/snackbar/snack-bar-service.service';
import { Roles } from '@models/base/identificadores.model';

// Auditoría QA (2026-08-10): pantallas como Permisos, Perfiles (CasosUso) y Roles ya estaban
// restringidas a SuperAdministrador del lado de la API (ver Permisos.sql — exclusión explícita
// "acordado con Nacho" para las categorías Permisos/Roles/ParametrosSistema/
// WhatsAppSistemaConfiguracion), pero del lado de Angular solo exigían estar autenticado
// (AuthGuardService). Un usuario no-SuperAdmin podía navegar directo a la URL y la pantalla
// cargaba igual, solo para recibir 403 de la API en cada request (grilla vacía / rota, sin
// mensaje claro de por qué). Este guard corta la navegación antes de eso.
@Injectable({ providedIn: 'root' })
export class SuperAdminGuardService {
  private loginService = inject(LoginService);
  private router = inject(Router);
  private snackBar = inject(SnackBarService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (this.loginService.getIdUserRol() === Roles.SuperAdministrador) {
      return true;
    }

    this.snackBar.showError('Esta sección es exclusiva para el Super Administrador.', 'Acceso restringido');
    return this.router.createUrlTree(['/dashboard']);
  }
}
